import { supabase } from "../supabase/SupabaseClient";
import { traerTodas } from "./paginar";
import { guardarEvento } from "../functions/eventFunctions";
import { eventos as camposEventos } from "../components/formularios/data/FormContent";
import { ENTREGA, RETIRA, filaMovimiento } from "../shared/llaves";

/* El control de llaves con QR (ticket 522). Lee y escribe en `eventos`, el
 * mismo lugar que el formulario de siempre: ver `shared/llaves.js`. */

/* Cuánto para atrás se mira. Una llave retirada hace dos meses y nunca anotada
 * de vuelta no es una llave que alguien tiene hoy, y traerlo todo serían miles
 * de filas para dibujar sesenta. */
export const DIAS = 60;

/* Los movimientos de llaves de los últimos `DIAS`. El `lt("fecha", "3")` deja
 * afuera las fechas heredadas de Firestore, que son texto JSON (`{"seconds"…`)
 * y en orden de texto caen DESPUÉS de cualquier año: sin el tope, el `gte` las
 * traería todas. */
export const movimientosLlaves = async (ahora = new Date()) => {
  const desde = new Date(ahora.getTime() - DIAS * 86400000).toISOString();
  return traerTodas(() =>
    supabase
      .from("eventos")
      .select("id,tipo,persona,operador,tractor,detalle,fecha,usuario_nombre", {
        count: "exact",
      })
      .in("tipo", [RETIRA, ENTREGA])
      .gte("fecha", desde)
      .lt("fecha", "3")
      // `traerTodas` pide el total y un orden que no empate: la fecha sola
      // puede repetirse, el id no.
      .order("fecha", { ascending: false })
      .order("id", { ascending: false }),
  );
};

/* Las confirmaciones de los choferes (`llaves_confirmaciones`, la lleva el
 * bot) de los últimos `DIAS`. Si no se pueden leer, tira: el que llama sigue
 * sin las marcas. */
export const confirmacionesLlaves = async (ahora = new Date()) => {
  const desde = new Date(ahora.getTime() - DIAS * 86400000).toISOString();
  return traerTodas(() =>
    supabase
      .from("llaves_confirmaciones")
      .select("id,interno,evento_id,chofer_nombre,confirmado_en,rechazado_en,cerrado_en,alerta_en", {
        count: "exact",
      })
      .gte("creado_en", desde)
      .order("id", { ascending: true }),
  );
};

/* Anota un retiro o una devolución. Devuelve el id del evento; si no se pudo,
 * tira el error tal cual y la pantalla lo dice. */
export const anotarMovimiento = async (mov) => {
  const r = await guardarEvento(
    null,
    filaMovimiento(mov),
    {},
    camposEventos.llaves,
    "porteria",
    false,
    false,
    null,
    { avisar: false },
  );
  return r?.id ?? null;
};
